import {toSiteBunnyAdminError} from "@/error";
import llmConfigRepository from "@/repository/LlmConfigRepository";
import {useQuery} from "@tanstack/react-query";
import {LlmConfig} from "@/model/llmSpecification";

const getData = async () => {
    try {
        const {data} = await llmConfigRepository.find();
        return data.result;
    } catch (e){
        throw toSiteBunnyAdminError(e);
    }
}

const useLlmConfig = () => {
    return useQuery<LlmConfig[]>({
        queryKey: ["llmConfig"],
        queryFn: async () => getData(),
        retry: false,
        suspense: false,
        useErrorBoundary: true,
    })

}

export default useLlmConfig;